import { useBlockProps } from '@wordpress/block-editor'

export default function useIsSelected(props: { checkChildren?: boolean } = {}) {
  const classes = useBlockProps().className?.split(' ')
  return (
    classes?.includes('is-selected') ||
    (props.checkChildren && classes?.includes('has-child-selected'))
  )
}
